module.exports = __webpack_public_path__ + "img/online-step-2.6e8d8e1f.png";